import moment from 'moment';
import { from } from 'rxjs';
import { settingConfigs } from '@/configurations';
import { DATE_CONSTANT, APP_LANGUAGE_SUPPORTS } from '@/constants/app';
export const utilsFunction = {
  currencyFormatter,
  getDateFromTimestamp,
  numberFormatter,
  formatNumber,
  formatPercent,
  modifyDateFromNow,
  switchToolTipsLanguage,
  instrumentIDZeroPadding,
  isNull,
  instrumentIDFunction,
  dateStringFormat
}

function currencyFormatter(original, decimal = 3, multiple = 1) {
  original = parseFloat(original) * multiple;
  if (!original || isNaN(original)
    || (original == '')) {
    original = 0;
  }
  original = original.toFixed(decimal);
  var m = /(\d+)(?:(\.\d+)|)/.exec(original + ''), x = m[1].length > 3 ? m[1].length % 3
    : 0;
  var n = parseFloat(m[1]).toFixed(0);
  var v = (original < 0 ? '-' : '')
    + (x ? n.substr(0, x) + ',' : '')
    + n.substr(x).replace(/(\d{3})(?=\d)/g, '$1' + ',');
  v += m[2] == undefined ? Number(0).toFixed(decimal).substr(1) : m[2]
  return v;
}

function getDateFromTimestamp(timestamp) {
  const result = {
    date: '',
    fromNow: ''
  }
  let now = moment().format('DD-MM-YYYY')
  // let date = moment(parseInt(timestamp)).format('DD-MM-YYYY HH:mm:ss');
  let date = moment(parseInt(timestamp)).format('DD-MM-YYYY');
  result.date = date;
  if (now === moment(parseInt(timestamp)).format('DD-MM-YYYY')) {
    let fromNow = moment(parseInt(timestamp)).fromNow();
    fromNow = fromNow.charAt(0).toUpperCase() + fromNow.slice(1);
    result.fromNow = fromNow;
  }
  return result;
}

function numberFormatter(original = 0, separator = ',') {
  original = parseInt(original);
  if (isNaN(original)) {
    return 0;
  }
  var m = /(\d+)(?:(\.\d+)|)/.exec(original + ''), x = m[1].length > 3 ? m[1].length % 3
    : 0;
  var n = parseFloat(m[1]).toFixed(0);
  var v = (original < 0 ? '-' : '')
    + (x ? n.substr(0, x) + separator : '')
    + n.substr(x).replace(/(\d{3})(?=\d)/g, '$1' + separator);

  return v;
}

function formatNumber(amount, decimalCount = 3, decimal = ".", thousands = ",") {
  amount = parseFloat(amount);
  if (!amount || isNaN(amount) || (amount == '')) {
    amount = 0;
  }

  if (amount === 0) {
    if(decimalCount === 2 ){
      return amount + '.00';
    }else if(decimalCount === 5){
      return amount + '.000';
    }else{
      return amount;
    }
  } 
  // else if (amount % 1 === 0 && decimalCount !== 2) {
  //   decimalCount = 0;
  // }

    if(decimalCount === 5){
      decimalCount = 3
    }
  decimalCount = Math.abs(decimalCount);
  decimalCount = isNaN(decimalCount) ? 3 : decimalCount;

  const negativeSign = amount < 0 ? "-" : "";

  let i = parseInt(amount = Math.abs(Number(amount) || 0).toFixed(decimalCount)).toString();
  let j = (i.length > 3) ? i.length % 3 : 0;

  return negativeSign + (j ? i.substr(0, j) + thousands : '') + i.substr(j).replace(/(\d{3})(?=\d)/g, "$1" + thousands) + (decimalCount ? decimal + Math.abs(amount - i).toFixed(decimalCount).slice(2) : "");
};

function formatPercent(value) {
  if (!value) {
    if (value == 0) {
      return '0.00%';
    } else {
      return '';
    }
  } else {
    return Number(value).toFixed(2) + '%';
  }
}

function modifyDateFromNow(operator, quantity, unit) {
  switch (operator) {
    case DATE_CONSTANT.ADD: return moment().add(quantity, unit).format(settingConfigs.SHORT_DATE);
    case DATE_CONSTANT.SUBTRACT: return moment().subtract(quantity, unit).format(settingConfigs.SHORT_DATE);
    default: return '';
  }
}

function switchToolTipsLanguage(language, en, cn, tc) {
  switch (language.lang) {
    case APP_LANGUAGE_SUPPORTS[0].id: {
      return tc ? tc : cn ? cn : en
    }
    case APP_LANGUAGE_SUPPORTS[1].id: {
      return cn ? cn : en
    }
    default: {
      return en
    }
  }
}

function instrumentIDZeroPadding(number) {
  if (number !== null && number !== undefined && number !== '' && number !== 'null') {
    if (typeof number !== 'number'){
      //let sun = number.length
      return '00000'.substring(number.length)+number
    }else{
      //number = Number(number)
      return (Array(5).join(0) + number).slice(-5)
    }
   
  }
}

function isNull(number){
  if (number !== null && number !== undefined && number !== '' && number !== 'null') {
    return true
  }else{
    return false
  }
}

function instrumentIDFunction(symbol,marketID){
  var len = symbol.length;
  var lvMaxSymbol = 9999;
  if(marketID == "MAMK"){
    lvMaxSymbol = 99999;
  }
  if(len > 0 && len <=lvMaxSymbol){
    if(marketID == "MAMK" || marketID == "SZMK"){
      symbol = "00000" + symbol;
      symbol = symbol.substr(len-1,6);
    }else{
      symbol = "0000" + symbol;
      symbol = symbol.substr(len-1,5);
    }
    return symbol
  };
}

function dateStringFormat(value) {
  var date = new Date(value)
  var year = date.getFullYear()
  var month = date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1
  var day = date.getDate() < 10 ? '0' + date.getDate() : date.getDate()
  var hours = date.getHours() < 10 ? '0' + date.getHours() : date.getHours()
  var minutes = date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes()
  var seconds = date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds()
  return year + '-' + month + '-' + day + ' ' + hours + ':' + minutes + ':' + seconds
}